var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEditIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 16,
    viewBox: "0 0 15 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.8906 12.7461H2.10938C1.8501 12.7461 1.64062 12.9556 1.64062 13.2148V13.7422C1.64062 13.8066 1.69336 13.8594 1.75781 13.8594H13.2422C13.3066 13.8594 13.3594 13.8066 13.3594 13.7422V13.2148C13.3594 12.9556 13.1499 12.7461 12.8906 12.7461ZM3.7749 11.5156C3.8042 11.5156 3.8335 11.5127 3.86279 11.5083L6.32666 11.0762C6.35596 11.0703 6.38379 11.0571 6.4043 11.0352L12.6138 4.82568C12.6273 4.81213 12.6381 4.79604 12.6455 4.77831C12.6528 4.76059 12.6566 4.7416 12.6566 4.72241C12.6566 4.70323 12.6528 4.68423 12.6455 4.66651C12.6381 4.64879 12.6273 4.63269 12.6138 4.61914L10.1792 2.18311C10.1514 2.15527 10.1147 2.14062 10.0752 2.14062C10.0356 2.14062 9.99902 2.15527 9.97119 2.18311L3.76172 8.39258C3.73975 8.41455 3.72656 8.44092 3.7207 8.47021L3.28857 10.9341C3.27432 11.0126 3.27942 11.0933 3.30341 11.1694C3.3274 11.2454 3.36957 11.3145 3.42627 11.3706C3.52295 11.4644 3.64453 11.5156 3.7749 11.5156Z",
    fill: "#FC686F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditIcon);
export default __webpack_public_path__ + "static/media/edit-icon.1261642dec9ddb3fdf0b6a029e1553c1.svg";
export { ForwardRef as ReactComponent };